import {
  GearSix,
  GraduationCap,
  House,
  ChartBar,
  Buildings,
  Calendar,
  CalendarBlank,
  ChartLineUp,
  ClipboardText,
  FileDoc,
  Robot,
  Scales,
  Users,
  Kanban,
  Ticket,
  WhatsappLogo,
  MagnifyingGlass,
  SquaresFour,
} from 'phosphor-react';
import type { IconProps } from 'phosphor-react';
import type { ForwardRefExoticComponent, RefAttributes } from 'react';
import HomePage from '../pages/home';
import { GroupsPage } from '../pages/groups';
import SecurityPage from '../pages/security';
import ProfilePage from '../pages/profile';
import CompanyPage from '../pages/company';
import SessionsPage from '../pages/sessions';
import GroupsCreatePage from '../pages/groups/create';
import { ApiControllerPage } from '../pages/api-controller';
import {
  ClienteNovoNaCentral,
  ClientesNaCentral,
  DepartamentoEditarRedireciona,
  DepartamentoNovoRedireciona,
  DepartamentosNaCentral,
  IpEditarRedireciona,
  IpNovoRedireciona,
  IpWhitelistNaCentral,
  LogsNaCentral,
  UsuarioEditarNaCentral,
  UsuarioNovoNaCentral,
  UsuariosRedireciona,
} from '../pages/permissoes/CabecalhoCentral';
import ClientesEditPage from '../pages/clientes/edit';
import modulesHomeIntegrationPage from '../pages/modulesHome/Integration';
import { ModulesHomeAccountingConciliationPage } from '../pages/modulesHome/accountingConciliation';
import { ModulesHomeFinanceiroPage } from '../pages/modulesHome/financeiro';
import { FinanceiroDiretoriaPage } from '../pages/modulesHome/financeiro/diretoria';
import { FinanceiroDashboardPage } from '../pages/modulesHome/financeiro/dashboard';
import { FinanceiroContasReceberPage } from '../pages/modulesHome/financeiro/contas-receber';
import { FinanceiroContasPagarPage } from '../pages/modulesHome/financeiro/contas-pagar';
import { FinanceiroDrePage } from '../pages/modulesHome/financeiro/dre';
import { FinanceiroInadimplenciaPage } from '../pages/modulesHome/financeiro/inadimplencia';
import { FinanceiroAuditoriaPage } from '../pages/modulesHome/financeiro/auditoria';
import { FinanceiroFluxoPage } from '../pages/modulesHome/financeiro/fluxo';
import { FinanceiroCustoPessoalPage } from '../pages/modulesHome/financeiro/custo-pessoal';
import { FinanceiroFranquiasPage } from '../pages/modulesHome/financeiro/franquias';
import { FinanceiroGapsPage } from '../pages/modulesHome/financeiro/gaps';
import { FinanceiroVendasPage } from '../pages/modulesHome/financeiro/vendas';
import { FinanceiroClientesPage } from '../pages/modulesHome/financeiro/clientes';
import { FinanceiroContratosPage } from '../pages/modulesHome/financeiro/contratos';
import { ConciliacaoContabilPage } from '../pages/modulesHome/accountingConciliation/conciliacao-contabil';
import { ConciliacaoContabilImportarPage } from '../pages/modulesHome/accountingConciliation/conciliacao-contabil/importar';
import { ConciliacaoContabilConciliarPage } from '../pages/modulesHome/accountingConciliation/conciliacao-contabil/conciliar';
import { ConciliacaoContabilRegrasPage } from '../pages/modulesHome/accountingConciliation/conciliacao-contabil/regras';
import { ConciliacaoContabilBancosPage } from '../pages/modulesHome/accountingConciliation/conciliacao-contabil/bancos';
import { ConciliacaoContabilExtratosPage } from '../pages/modulesHome/accountingConciliation/conciliacao-contabil/extratos';
import { ConciliacaoContabilDashboardPage } from '../pages/modulesHome/accountingConciliation/conciliacao-contabil/dashboard';
import { ConciliacaoContabilPlanoContasPage } from '../pages/modulesHome/accountingConciliation/conciliacao-contabil/plano-contas';
import { ConciliacaoContabilEmpresasPage } from '../pages/modulesHome/accountingConciliation/conciliacao-contabil/empresas';
import { ConciliacaoContabilSchoolAiPage } from '../pages/modulesHome/accountingConciliation/conciliacao-contabil/school-ai';
import { ConciliacaoContabilExportarPage } from '../pages/modulesHome/accountingConciliation/conciliacao-contabil/exportar';
import { modulesHomePersonnelDepartmentPayRollPage } from '../pages/modulesHome/payRoll';
import { modulesHomeSupervisorPage } from '../pages/modulesHome/Supervisor';
import { modulesHomeTaxPlanningPage } from '../pages/modulesHome/taxPlanning';
import GroupsEditPage from '../pages/groups/edit';
import MotivosAnotacaoPage from '../pages/configuracoes/motivos-anotacao';
import { CompaniesPage } from '../pages/companies';
import { AnaliseSociosPage } from '../pages/analiseSocios';
import { BreaksPage } from '../pages/breaks';
import { ModulesHomeIntegrationSequenceBreakPage } from '../pages/modulesHome/Integration/sequenceBreak';
import { ModulesHomeIntegrationBillingAnalysisPage } from '../pages/modulesHome/Integration/billingAnalysis';
import { ModulesHomeIntegrationApiXSiegPage } from '../pages/modulesHome/Integration/apiXSieg';
import { ConferenciaFiscalPage } from '../pages/modulesHome/Integration/conferenciaFiscal';
import { ModulesHomeIntegrationApiXSiegNotasPage } from '../pages/modulesHome/Integration/apiXSieg/showNotas';
import { SymplaPage } from '../pages/sympla';
import { ViewSymplaPage } from '../pages/sympla/view';
import { ModulesHomeIntegrationDailyImportsPage } from '../pages/modulesHome/Integration/dailyImports';
import { ModulesHomeIntegrationManualPostingsPage } from '../pages/modulesHome/Integration/manualPostings';
import { SupervisorSimplesPage } from '../pages/modulesHome/Supervisor/simplesProprio/SupervisorSimplesPage';
import { FaturasSimplesPage } from '../pages/modulesHome/Supervisor/simplesProprio/FaturasPage';
import { modulesHomeSupervisorLucroRealPage } from '../pages/modulesHome/Supervisor/lucroReal';
import { modulesHomeSupervisorLucroPresumidoPage } from '../pages/modulesHome/Supervisor/lucroPresumido';
import { ModulesHomeSupervisorTaxAnalysisPage } from '../pages/modulesHome/Supervisor/taxAnalysis';
import { ModulesHomeSupervisorTaxAnalysisSNPage } from '../pages/modulesHome/Supervisor/taxAnalysisSN';
import { IcmsHomePage } from '../pages/modulesHome/Supervisor/icms';
import { IcmsDifalCarteiraPage } from '../pages/modulesHome/Supervisor/icms/difal';
import { IcmsDifalEmpresaPage } from '../pages/modulesHome/Supervisor/icms/difal/empresa';
import { IcmsAcumuladoresHomePage } from '../pages/modulesHome/Supervisor/icms/acumuladores';
import { IcmsAcumuladoresEmpresaPage } from '../pages/modulesHome/Supervisor/icms/acumuladores/empresa';
import { IcmsLivrosFiscaisHomePage } from '../pages/modulesHome/Supervisor/icms/livrosFiscais';
import { IcmsLivrosFiscaisEmpresaPage } from '../pages/modulesHome/Supervisor/icms/livrosFiscais/empresa';
import { IcmsRegimeEspecialPage } from '../pages/modulesHome/Supervisor/icms/regimeEspecial';
import {
  NfseEmissaoPainelPage,
  NfseEmissaoFormPage,
  NfseEmissaoNotasPage,
  NfseEmissaoNotaPage,
  NfseEmissaoCertificadosPage,
  NfseEmissaoEmpresasPage,
} from '../pages/modulesHome/Supervisor/nfseEmissao';
import { ModulesHomeSupervisorTaxRegimePage } from '../pages/modulesHome/Supervisor/taxRegime';
import { ModulesHomeSupervisorPartinerPage } from '../pages/modulesHome/Supervisor/partner';
import { ModulesHomeSupervisorPartnerCompaniesPage } from '../pages/modulesHome/Supervisor/partner/viewCompanies';
import { ViewNotasManualPosting } from '../pages/modulesHome/Integration/manualPostings/showNotas';
import { ModulesHomeIntegrationApiXSiegNotasSiegPage } from '../pages/modulesHome/Integration/apiXSieg/showNotasSieg';
import { ModulesHomeIntegrationNfseManagementPage } from '../pages/modulesHome/Integration/nfseManagement';
import { ModulesHomeIntegrationNfseManagementShowNotasPage } from '../pages/modulesHome/Integration/nfseManagement/showNotas';
import { ModulesHomeIntegrationNfseExplorerPage } from '../pages/modulesHome/Integration/nfseDashboard';
import { ModulesHomeIntegrationImportsDashboardPage } from '../pages/modulesHome/Integration/importsDashboard';
import { ModulesHomeIntegrationDuplicateNotesPage } from '../pages/modulesHome/Integration/duplicateNotes';
import { ModulesHomeIntegrationDuplicateNotesShowPage } from '../pages/modulesHome/Integration/duplicateNotes/showNotas';
import ChatEnhancedPage from '../pages/chat/ChatEnhanced';
import ModulesDashBoardPersonnelDepartmentPage from '../pages/modulesHome/personnelDepartment';
import { BotConfigPage } from '../pages/botConfig';
import { AutomacaoPage } from '../pages/automacao';
import { OrquestradorDashboardPage } from '../pages/orquestrador';
import {
  RedirectToAnalise,
  RedirectToLogs,
  RedirectPermissoesDoGrupo,
  RedirectPermissoesEventos,
  RedirectTelasDoSistema,
} from './redirects';
import { EmpresaDashboardPage } from '../pages/empresaDashboard';
import { BalanceteContabilPage } from '../pages/modulesHome/accountingConciliation/balancete';
import { FechamentoContabilMensalPage } from '../pages/modulesHome/accountingConciliation/fechamento-contabil-mensal';
import { FechamentoContabilEmpresaPage } from '../pages/modulesHome/accountingConciliation/fechamento-contabil-mensal/empresa';
import { PapelTrabalhoContaPage } from '../pages/modulesHome/accountingConciliation/balancete/conta';
import { FechamentosPage } from '../pages/modulesHome/accountingConciliation/fechamentos';
import { ModulesHomeAccountingConciliationFiscalContabilPage } from '../pages/modulesHome/accountingConciliation/fiscalcontabil';
import {
  ModulesHomeFiscalVarianciaNotaPage,
  ModulesHomeFiscalAuditoriaPage,
  EfdErrosPage,
} from '../pages/modulesHome/Fiscal';
import { DossieEmpresaPage } from '../pages/modulesHome/dossieEmpresa';
import { AuditoriaHubPage } from '../pages/modulesHome/auditoriaInteligente/HubPage';
import {
  AuditoriaDashboardPage,
  AuditoriaDossiePage,
  AuditoriaFiscalPage,
  AuditoriaNotasPage,
  AuditoriaImpostosApuradosPage,
  AuditoriaImpostosPorNotaPage,
  AuditoriaAcumuladoresPage,
  AuditoriaSimplesPage,
  AuditoriaClientesFornPage,
  AuditoriaContabilPage,
  AuditoriaPessoalPage,
  AuditoriaSocietarioPage,
  AuditoriaManuaisPage,
  AuditoriaAuditoriasPage,
  AuditoriaCruzamentosPage,
  AuditoriaIntegracaoPage,
  AuditoriaObrigacoesPage,
  AuditoriaFechamentoPage,
  AuditoriaEscritorioPage,
} from '../pages/modulesHome/auditoriaInteligente/pages';
import { KanbanProjectsPage } from '../pages/kanban/projects';
import { KanbanBoardPage } from '../pages/kanban/board';
import EventosPage from '../pages/eventos';
import EventosKanbanPage from '../pages/eventos/kanban';
import EventoContratoPage from '../pages/eventos/contrato';
import EventoPage from '../pages/eventos/evento';
import { SocietarioHomePage } from '../pages/societario';
import { SocietarioContratosPage } from '../pages/societario/contratos';
import { SocietarioContratoCriarPage } from '../pages/societario/contratos/criar';
import { SocietarioTemplatesPage } from '../pages/societario/templates';
import { SocietarioModelosPage } from '../pages/societario/modelos';
import { SocietarioSociosPage } from '../pages/societario/socios';
import { SocietarioAdminMetricsPage } from '../pages/societario/admin/metrics';
import { LegalizacaoPage } from '../pages/societario/legalizacao';
import { EstatutoPage } from '../pages/modulesHome/Estatuto';
import { CentralPermissoesPage } from '../pages/permissoes';
import { CatalogoTelasPage } from '../pages/permissoes/catalogo';
import WhatsAppChatPage from '../pages/whatsapp';
import WaDashboardWrapper from '../pages/whatsapp/WaDashboardWrapper';
import WaKanbanWrapper from '../pages/whatsapp/WaKanbanWrapper';
import WaClientsPage from '../pages/whatsapp/WaClientsPage';
import WaReportsPage from '../pages/whatsapp/WaReportsPage';
import WaConnectionPage from '../pages/whatsapp/WaConnectionPage';
import WaBotConfigPage from '../pages/whatsapp/WaBotConfigPage';
import WaAiInsightsPage from '../pages/whatsapp/WaAiInsightsPage';
import WaHistoryPage from '../pages/whatsapp/WaHistoryPage';
import WaTemplatesPage from '../pages/whatsapp/WaTemplatesPage';

export type IMenuIcon = ForwardRefExoticComponent<IconProps & RefAttributes<SVGSVGElement>>;
export interface IPrivateRoutes {
  /** Código único da tela em kebab-case (ex: 'integracao-quebra-sequencia') */
  codigo?: string;
  /** Nome legível para exibição na UI */
  name: string;
  /** Path da rota (URL original) */
  path: string;
  component?: () => JSX.Element | undefined;
  componentCreate?: () => JSX.Element | undefined;
  componentEdit?: () => JSX.Element | undefined;
  componentShow?: () => JSX.Element | undefined;
  isParentMenu?: boolean;
  isChildrenMenu?: boolean;
  parentMenu?: string;
  showSidebar: boolean;
  icon?: IMenuIcon;
  permissionSympla?: boolean;
  /**
   * Rota usa visual glassmorphism (sem moldura/padding do layout padrao,
   * usa GlassPageBg internamente). Layout consulta essa flag.
   */
  isGlass?: boolean;
  /** Vira aba da Central de Permissões: some do menu para quem abre a Central. */
  naCentral?: boolean;
  /**
   * Rota raiz de modulo que apresenta sidebar drill-down (entrar no modulo
   * troca o sidebar por uma versao especifica do modulo, com botao "Voltar").
   * Sidebar consulta essa flag pra decidir o modo.
   */
  hasDrillSidebar?: boolean;
  /**
   * Submódulo aposentado: some das listas de submódulo (home do módulo + sidebar drill),
   * mas a rota segue acessível por URL até a remoção definitiva do código.
   */
  hiddenSubmodule?: boolean;
  /**
   * Rota que só redireciona (endereço antigo): não vira tela no catálogo de
   * permissões e não aparece para liberar na Central.
   */
  semTela?: boolean;
  /**
   * Link do submódulo quando o path tem parâmetro (ex.: `/emitir/:id?`): a rota entra na
   * lista de submódulos com este endereço, sem parâmetro.
   */
  submoduleLink?: string;
}

export const PrivateRoutes: IPrivateRoutes[] = [
  {
    name: 'Módulos',
    path: '/',
    component: HomePage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: true,
    icon: House,
  },
  {
    codigo: 'integracao-quebra-sequencia',
    name: 'integration sequenceBreak',
    path: '/modulesHome/integration/sequenceBreak',
    component: ModulesHomeIntegrationSequenceBreakPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartBar,
  },
  {
    codigo: 'integracao-analise-faturamento',
    name: 'integration billingAnalysis',
    path: '/modulesHome/integration/billingAnalysis',
    component: ModulesHomeIntegrationBillingAnalysisPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartBar,
  },
  {
    codigo: 'fiscal-variancia-nota',
    name: 'fiscal varianciaNota',
    path: '/modulesHome/fiscal/variancia-nota',
    component: ModulesHomeFiscalVarianciaNotaPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartLineUp,
  },
  {
    codigo: 'fiscal-auditoria-calculo',
    name: 'fiscal auditoriaFiscal',
    path: '/modulesHome/fiscal/auditoria-calculo',
    component: ModulesHomeFiscalAuditoriaPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartLineUp,
  },
  {
    codigo: 'fiscal-efd-erros',
    name: 'fiscal efdErros',
    path: '/modulesHome/fiscal/efd-erros',
    component: EfdErrosPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartLineUp,
  },
  {
    codigo: 'chat-pro',
    name: 'chat pro',
    path: '/chatPro',
    component: ChatEnhancedPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartBar,
  },
  {
    codigo: 'integracao-analise-xml',
    name: 'integration apixsieg',
    path: '/modulesHome/integration/apixsieg',
    component: ModulesHomeIntegrationApiXSiegPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: ModulesHomeIntegrationApiXSiegNotasPage,
    showSidebar: false,
    icon: ChartBar,
  },
  {
    codigo: 'integracao-analise-xml-sieg',
    name: 'integration xmlAnalysis',
    path: '/modulesHome/integration/apixsieg/Sieg',
    component: undefined,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: ModulesHomeIntegrationApiXSiegNotasSiegPage,
    showSidebar: false,
    icon: ChartBar,
  },
  {
    // Conferência Fiscal — substitui o api_sieg (Comparativo de Importações).
    // Compara Domínio x Fiscal (xml_*) x Portal Nacional. Design glass.
    codigo: 'integracao-conferencia-fiscal',
    name: 'integration conferenciaFiscal',
    path: '/modulesHome/integration/conferencia-fiscal',
    component: ConferenciaFiscalPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartBar,
    isGlass: true,
  },
  {
    codigo: 'integracao-importacoes-diarias',
    name: 'integration dailyImports',
    path: '/modulesHome/integration/dailyImports',
    component: ModulesHomeIntegrationDailyImportsPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartBar,
  },
  {
    codigo: 'dossie-empresa',
    name: 'Dossiê da Empresa',
    path: '/dossie-empresa/:externalId',
    component: DossieEmpresaPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartBar,
  },
  {
    codigo: 'auditoria-inteligente',
    name: 'Auditoria Inteligente',
    path: '/modulesHome/auditoria-inteligente',
    component: AuditoriaHubPage,
    showSidebar: false,
    icon: MagnifyingGlass,
    isGlass: true,
    hasDrillSidebar: true,
  },
  {
    codigo: 'auditoria-dashboard',
    name: 'Dashboard',
    path: '/modulesHome/auditoria-inteligente/dashboard',
    component: AuditoriaDashboardPage,
    showSidebar: false,
    icon: MagnifyingGlass,
    isGlass: true,
  },
  {
    codigo: 'auditoria-dossie',
    name: 'Dossiê 360',
    path: '/modulesHome/auditoria-inteligente/dossie',
    component: AuditoriaDossiePage,
    showSidebar: false,
    icon: MagnifyingGlass,
    isGlass: true,
  },
  {
    codigo: 'auditoria-fiscal',
    name: 'Fiscal — Visão Geral',
    path: '/modulesHome/auditoria-inteligente/fiscal',
    component: AuditoriaFiscalPage,
    showSidebar: false,
    icon: MagnifyingGlass,
    isGlass: true,
  },
  {
    codigo: 'auditoria-notas',
    name: 'Notas Fiscais',
    path: '/modulesHome/auditoria-inteligente/notas',
    component: AuditoriaNotasPage,
    showSidebar: false,
    icon: MagnifyingGlass,
    isGlass: true,
  },
  {
    codigo: 'auditoria-impostos-apurados',
    name: 'Impostos Apurados',
    path: '/modulesHome/auditoria-inteligente/impostos-apurados',
    component: AuditoriaImpostosApuradosPage,
    showSidebar: false,
    icon: MagnifyingGlass,
    isGlass: true,
  },
  {
    codigo: 'auditoria-impostos-por-nota',
    name: 'Impostos por Nota',
    path: '/modulesHome/auditoria-inteligente/impostos-por-nota',
    component: AuditoriaImpostosPorNotaPage,
    showSidebar: false,
    icon: MagnifyingGlass,
    isGlass: true,
  },
  {
    codigo: 'auditoria-acumuladores',
    name: 'Acumuladores',
    path: '/modulesHome/auditoria-inteligente/acumuladores',
    component: AuditoriaAcumuladoresPage,
    showSidebar: false,
    icon: MagnifyingGlass,
    isGlass: true,
  },
  {
    codigo: 'auditoria-simples',
    name: 'Simples Nacional',
    path: '/modulesHome/auditoria-inteligente/simples',
    component: AuditoriaSimplesPage,
    showSidebar: false,
    icon: MagnifyingGlass,
    isGlass: true,
  },
  {
    codigo: 'auditoria-clientes-fornecedores',
    name: 'Clientes & Fornecedores',
    path: '/modulesHome/auditoria-inteligente/clientes-fornecedores',
    component: AuditoriaClientesFornPage,
    showSidebar: false,
    icon: MagnifyingGlass,
    isGlass: true,
  },
  {
    codigo: 'auditoria-contabil',
    name: 'Contábil',
    path: '/modulesHome/auditoria-inteligente/contabil',
    component: AuditoriaContabilPage,
    showSidebar: false,
    icon: MagnifyingGlass,
    isGlass: true,
  },
  {
    codigo: 'auditoria-pessoal',
    name: 'Pessoal',
    path: '/modulesHome/auditoria-inteligente/pessoal',
    component: AuditoriaPessoalPage,
    showSidebar: false,
    icon: MagnifyingGlass,
    isGlass: true,
  },
  {
    codigo: 'auditoria-societario',
    name: 'Quadro Societário',
    path: '/modulesHome/auditoria-inteligente/societario',
    component: AuditoriaSocietarioPage,
    showSidebar: false,
    icon: MagnifyingGlass,
    isGlass: true,
  },
  {
    codigo: 'auditoria-manuais',
    name: 'Notas Manuais',
    path: '/modulesHome/auditoria-inteligente/manuais',
    component: AuditoriaManuaisPage,
    showSidebar: false,
    icon: MagnifyingGlass,
    isGlass: true,
  },
  {
    codigo: 'auditoria-auditorias',
    name: 'Auditorias',
    path: '/modulesHome/auditoria-inteligente/auditorias',
    component: AuditoriaAuditoriasPage,
    showSidebar: false,
    icon: MagnifyingGlass,
    isGlass: true,
  },
  {
    codigo: 'auditoria-cruzamentos',
    name: 'Cruzamentos por Área',
    path: '/modulesHome/auditoria-inteligente/cruzamentos',
    component: AuditoriaCruzamentosPage,
    showSidebar: false,
    icon: MagnifyingGlass,
    isGlass: true,
  },
  {
    codigo: 'auditoria-integracao',
    name: 'Integração Fiscal-Contábil',
    path: '/modulesHome/auditoria-inteligente/integracao',
    component: AuditoriaIntegracaoPage,
    showSidebar: false,
    icon: MagnifyingGlass,
    isGlass: true,
  },
  {
    codigo: 'auditoria-obrigacoes',
    name: 'Obrigações Acessórias',
    path: '/modulesHome/auditoria-inteligente/obrigacoes',
    component: AuditoriaObrigacoesPage,
    showSidebar: false,
    icon: MagnifyingGlass,
    isGlass: true,
  },
  {
    codigo: 'auditoria-fechamento',
    name: 'Acompanhamento de Fechamento',
    path: '/modulesHome/auditoria-inteligente/fechamento',
    component: AuditoriaFechamentoPage,
    showSidebar: false,
    icon: MagnifyingGlass,
    isGlass: true,
  },
  {
    codigo: 'auditoria-escritorio',
    name: 'Gestão do Escritório',
    path: '/modulesHome/auditoria-inteligente/escritorio',
    component: AuditoriaEscritorioPage,
    showSidebar: false,
    icon: MagnifyingGlass,
    isGlass: true,
  },
  {
    codigo: 'integracao-lancamentos-manuais',
    name: 'integration manualPostings',
    path: '/modulesHome/integration/manualPostings',
    component: ModulesHomeIntegrationManualPostingsPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: ViewNotasManualPosting,
    showSidebar: false,
    icon: ChartBar,
  },
  {
    codigo: 'integracao-gestao-nfse',
    name: 'integration nfseManagement',
    path: '/modulesHome/integration/nfseManagement',
    component: ModulesHomeIntegrationNfseManagementPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: ModulesHomeIntegrationNfseManagementShowNotasPage,
    showSidebar: false,
    icon: ChartBar,
  },
  {
    codigo: 'integracao-dashboard-nfse',
    name: 'integration nfseDashboard',
    path: '/modulesHome/integration/nfseDashboard',
    component: ModulesHomeIntegrationNfseExplorerPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartBar,
  },
  {
    codigo: 'integracao-dashboard-importacoes',
    name: 'integration importsDashboard',
    path: '/modulesHome/integration/importsDashboard',
    component: ModulesHomeIntegrationImportsDashboardPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartBar,
  },
  {
    codigo: 'integracao-notas-duplicadas',
    name: 'integration duplicateNotes',
    path: '/modulesHome/integration/duplicateNotes',
    component: ModulesHomeIntegrationDuplicateNotesPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: ModulesHomeIntegrationDuplicateNotesShowPage,
    showSidebar: false,
    icon: ChartBar,
  },
  {
    codigo: 'quebras',
    name: 'Quebras',
    path: '/breaks',
    component: undefined,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: BreaksPage,
    showSidebar: false,
    icon: ChartBar,
  },
  {
    codigo: 'empresas',
    name: 'Empresas',
    path: '/empresas',
    isParentMenu: true,
    component: CompaniesPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: true,
    icon: Buildings,
  },
  {
    codigo: 'empresas-listagem',
    name: 'Listagem',
    path: '/empresas/listagem',
    component: CompaniesPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: true,
    isChildrenMenu: true,
    parentMenu: 'Empresas',
    icon: Buildings,
  },
  {
    codigo: 'empresas-dashboard',
    name: 'Dashboard',
    path: '/empresas/dashboard',
    component: EmpresaDashboardPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: true,
    isChildrenMenu: true,
    parentMenu: 'Empresas',
    icon: ChartBar,
  },
  {
    codigo: 'empresas-analise-socios',
    name: 'Análise de Sócios',
    path: '/empresas/analise-socios',
    component: AnaliseSociosPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: true,
    isChildrenMenu: true,
    parentMenu: 'Empresas',
    icon: Users,
  },
  {
    codigo: 'sympla',
    name: 'Sympla',
    path: '/sympla',
    component: SymplaPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: ViewSymplaPage,
    showSidebar: true,
    icon: CalendarBlank,
  },
  {
    codigo: 'integracao-dashboard',
    name: 'Modulos do dashboard integration',
    path: '/modulesHome/integration',
    component: modulesHomeIntegrationPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: House,
    isGlass: true,
    hasDrillSidebar: true,
  },
  {
    codigo: 'dp-dashboard',
    name: 'Modulos do dashboard personnelDepartment',
    path: '/modulesHome/personnelDepartment',
    component: ModulesDashBoardPersonnelDepartmentPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: House,
  },
  {
    codigo: 'dp-folha-pagamento',
    name: 'Modulos do dashboard personnelDepartment payRoll',
    path: '/modulesHome/personnelDepartment/payRoll',
    component: modulesHomePersonnelDepartmentPayRollPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: House,
  },
  {
    codigo: 'conciliacao-contabil-dashboard',
    name: 'Modulos do dashboard accountingConciliation',
    path: '/modulesHome/accountingConciliation',
    component: ModulesHomeAccountingConciliationPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: House,
    isGlass: true,
    hasDrillSidebar: true,
  },
  {
    codigo: 'financeiro-dashboard-hub',
    name: 'Financeiro',
    path: '/modulesHome/financeiro',
    component: ModulesHomeFinanceiroPage,
    showSidebar: false,
    icon: House,
    isGlass: true,
    hasDrillSidebar: true,
  },
  {
    codigo: 'financeiro-diretoria',
    name: 'Dashboard Diretoria',
    path: '/modulesHome/financeiro/diretoria',
    component: FinanceiroDiretoriaPage,
    showSidebar: false,
    icon: House,
    isGlass: true,
  },
  {
    codigo: 'financeiro-dashboard',
    name: 'Dashboard',
    path: '/modulesHome/financeiro/dashboard',
    component: FinanceiroDashboardPage,
    showSidebar: false,
    icon: House,
    isGlass: true,
  },
  {
    codigo: 'financeiro-contas-receber',
    name: 'Contas a Receber',
    path: '/modulesHome/financeiro/contas-receber',
    component: FinanceiroContasReceberPage,
    showSidebar: false,
    icon: House,
    isGlass: true,
  },
  {
    codigo: 'financeiro-contas-pagar',
    name: 'Contas a Pagar',
    path: '/modulesHome/financeiro/contas-pagar',
    component: FinanceiroContasPagarPage,
    showSidebar: false,
    icon: House,
    isGlass: true,
  },
  {
    codigo: 'financeiro-dre',
    name: 'DRE / Resultado',
    path: '/modulesHome/financeiro/dre',
    component: FinanceiroDrePage,
    showSidebar: false,
    icon: House,
    isGlass: true,
  },
  {
    codigo: 'financeiro-inadimplencia',
    name: 'Inadimplência',
    path: '/modulesHome/financeiro/inadimplencia',
    component: FinanceiroInadimplenciaPage,
    showSidebar: false,
    icon: House,
    isGlass: true,
  },
  {
    codigo: 'financeiro-auditoria',
    name: 'Auditoria de dados',
    path: '/modulesHome/financeiro/auditoria',
    component: FinanceiroAuditoriaPage,
    showSidebar: false,
    icon: House,
    isGlass: true,
  },
  {
    codigo: 'financeiro-fluxo',
    name: 'Fluxo de Caixa',
    path: '/modulesHome/financeiro/fluxo',
    component: FinanceiroFluxoPage,
    showSidebar: false,
    icon: House,
    isGlass: true,
  },
  {
    codigo: 'financeiro-custo-pessoal',
    name: 'Custo de Pessoal',
    path: '/modulesHome/financeiro/custo-pessoal',
    component: FinanceiroCustoPessoalPage,
    showSidebar: false,
    icon: House,
    isGlass: true,
  },
  {
    codigo: 'financeiro-franquias',
    name: 'Comparativo de Franquias',
    path: '/modulesHome/financeiro/franquias',
    component: FinanceiroFranquiasPage,
    showSidebar: false,
    icon: House,
    isGlass: true,
  },
  {
    codigo: 'financeiro-gaps',
    name: 'Gaps recebíveis × pagos',
    path: '/modulesHome/financeiro/gaps',
    component: FinanceiroGapsPage,
    showSidebar: false,
    icon: House,
    isGlass: true,
  },
  {
    codigo: 'financeiro-vendas',
    name: 'Vendas',
    path: '/modulesHome/financeiro/vendas',
    component: FinanceiroVendasPage,
    showSidebar: false,
    icon: House,
    isGlass: true,
  },
  {
    codigo: 'financeiro-clientes',
    name: 'Ranking de Clientes',
    path: '/modulesHome/financeiro/clientes',
    component: FinanceiroClientesPage,
    showSidebar: false,
    icon: House,
    isGlass: true,
  },
  {
    codigo: 'financeiro-contratos',
    name: 'Contratos / MRR',
    path: '/modulesHome/financeiro/contratos',
    component: FinanceiroContratosPage,
    showSidebar: false,
    icon: House,
    isGlass: true,
  },
  {
    codigo: 'conciliacao-fechamentos',
    name: 'Acompanhamento de Fechamentos',
    path: '/modulesHome/accountingConciliation/fechamentos',
    component: FechamentosPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: Calendar,
    isGlass: true,
  },
  {
    codigo: 'conciliacao-fiscal-contabil',
    name: 'Integração Fiscal Contábil',
    path: '/modulesHome/accountingConciliation/fiscalcontabil',
    component: ModulesHomeAccountingConciliationFiscalContabilPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartBar,
    isGlass: true,
  },
  {
    // Submodulo ContaCil — conciliacao bancaria + categorizacao + export Dominio.
    // Codigo proprio (nao reusa 'conciliacao-contabil-dashboard' do modulo pai).
    codigo: 'contacil-dashboard',
    name: 'Conciliação Contábil',
    path: '/modulesHome/accountingConciliation/conciliacao-contabil',
    component: ConciliacaoContabilPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartBar,
    isGlass: true,
  },
  {
    codigo: 'contacil-importar',
    name: 'Importar Extrato',
    path: '/modulesHome/accountingConciliation/conciliacao-contabil/importar',
    component: ConciliacaoContabilImportarPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartBar,
    isGlass: true,
  },
  {
    codigo: 'contacil-conciliar',
    name: 'Conciliar',
    path: '/modulesHome/accountingConciliation/conciliacao-contabil/conciliar',
    component: ConciliacaoContabilConciliarPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartBar,
    isGlass: true,
  },
  {
    codigo: 'contacil-regras',
    name: 'Regras de Categorização',
    path: '/modulesHome/accountingConciliation/conciliacao-contabil/regras',
    component: ConciliacaoContabilRegrasPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartBar,
    isGlass: true,
  },
  {
    codigo: 'contacil-bancos',
    name: 'Contas Bancárias',
    path: '/modulesHome/accountingConciliation/conciliacao-contabil/bancos',
    component: ConciliacaoContabilBancosPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartBar,
    isGlass: true,
  },
  {
    codigo: 'contacil-extratos',
    name: 'Extratos enviados',
    path: '/modulesHome/accountingConciliation/conciliacao-contabil/extratos',
    component: ConciliacaoContabilExtratosPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartBar,
    isGlass: true,
  },
  {
    // Codigo proprio (nao reusa 'contacil-dashboard' do hub pai, linha ~865).
    codigo: 'contacil-dashboard-relatorio',
    name: 'Dashboard',
    path: '/modulesHome/accountingConciliation/conciliacao-contabil/dashboard',
    component: ConciliacaoContabilDashboardPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartBar,
    isGlass: true,
  },
  {
    codigo: 'contacil-plano-contas',
    name: 'Plano de Contas',
    path: '/modulesHome/accountingConciliation/conciliacao-contabil/plano-contas',
    component: ConciliacaoContabilPlanoContasPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartBar,
    isGlass: true,
  },
  {
    codigo: 'contacil-empresas',
    name: 'Empresas',
    path: '/modulesHome/accountingConciliation/conciliacao-contabil/empresas',
    component: ConciliacaoContabilEmpresasPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartBar,
    isGlass: true,
  },
  {
    codigo: 'contacil-school-ai',
    name: 'School AI',
    path: '/modulesHome/accountingConciliation/conciliacao-contabil/school-ai',
    component: ConciliacaoContabilSchoolAiPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartBar,
    isGlass: true,
  },
  {
    codigo: 'contacil-exportar',
    name: 'Exportar Domínio',
    path: '/modulesHome/accountingConciliation/conciliacao-contabil/exportar',
    component: ConciliacaoContabilExportarPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartBar,
    isGlass: true,
  },
  {
    // Composição de Saldo — porta de entrada do papel de trabalho da conta.
    // Fica no módulo Contábil (NAO dentro do ContaCil, que é conciliação
    // BANCÁRIA). O path segue `/balancete` de propósito: renomear a URL
    // quebraria links já compartilhados e a rota filha `/balancete/conta`.
    codigo: 'contabil-balancete',
    name: 'Composição de Saldo',
    path: '/modulesHome/accountingConciliation/balancete',
    component: BalanceteContabilPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartBar,
    isGlass: true,
  },
  {
    // Fechamento Contábil Mensal — revisão do fechamento de cada competência:
    // carteira, resumo da empresa e constatações. A tela nunca calcula: lê o
    // que o lote publicou. O nome evita os dois "Acompanhamento de Fechamento(s)".
    codigo: 'contabil-fechamento-mensal',
    name: 'Fechamento Contábil Mensal',
    path: '/modulesHome/accountingConciliation/fechamento-contabil-mensal',
    component: FechamentoContabilMensalPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartBar,
    isGlass: true,
  },
  {
    // Detalhe de uma empresa numa competência. Dois segmentos de propósito: não
    // vira card no módulo, só é alcançado pela carteira.
    codigo: 'contabil-fechamento-mensal-empresa',
    name: 'Fechamento Contábil Mensal — empresa',
    path: '/modulesHome/accountingConciliation/fechamento-contabil-mensal/empresa',
    component: FechamentoContabilEmpresaPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartBar,
    isGlass: true,
  },
  {
    // Papel de trabalho da conta (Composição de Saldo). Destino do clique numa
    // conta analítica da Composição de Saldo — contrato em `papelDeTrabalhoUrl`.
    codigo: 'contabil-papel-trabalho',
    name: 'Papel de trabalho da conta',
    path: '/modulesHome/accountingConciliation/balancete/conta',
    component: PapelTrabalhoContaPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartBar,
    isGlass: true,
  },
  {
    codigo: 'supervisor-dashboard',
    name: 'Modulos do dashboard supervisor',
    path: '/modulesHome/supervisor',
    component: modulesHomeSupervisorPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: House,
    isGlass: true,
    hasDrillSidebar: true,
  },
  {
    codigo: 'supervisor-lucro-real',
    name: 'Modulos do dashboard supervisor lucro real',
    path: '/modulesHome/supervisor/lucro-real',
    component: modulesHomeSupervisorLucroRealPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: House,
    isGlass: true,
  },
  {
    codigo: 'supervisor-lucro-presumido',
    name: 'Modulos do dashboard supervisor lucro presumido',
    path: '/modulesHome/supervisor/lucro-presumido',
    component: modulesHomeSupervisorLucroPresumidoPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: House,
    isGlass: true,
  },
  {
    codigo: 'supervisor-regime-tributario',
    name: 'Modulos do dashboard supervisor regime tributario',
    path: '/modulesHome/supervisor/taxRegime',
    component: ModulesHomeSupervisorTaxRegimePage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: House,
  },
  {
    codigo: 'supervisor-socios',
    name: 'Modulos do dashboard supervisor partner',
    path: '/modulesHome/supervisor/partner',
    component: ModulesHomeSupervisorPartinerPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: House,
  },
  {
    codigo: 'supervisor-socios-empresas',
    name: 'Modulos do dashboard supervisor partner companies',
    path: '/modulesHome/supervisor/partner',
    component: undefined,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: ModulesHomeSupervisorPartnerCompaniesPage,
    showSidebar: false,
    icon: ChartBar,
  },
  {
    // Simples Nacional calculado no sistema (apuração, auditoria, PGDAS-D). Design glass.
    codigo: 'supervisor-simples-nacional',
    name: 'Modulos do dashboard simples',
    path: '/modulesHome/supervisor/simples',
    component: SupervisorSimplesPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: House,
    isGlass: true,
  },
  {
    // Receita sem nota (fatura, recibo) que entra na apuração do Simples.
    codigo: 'supervisor-simples-faturas',
    name: 'Faturas do Simples Nacional',
    path: '/modulesHome/supervisor/simples/faturas',
    component: FaturasSimplesPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: House,
    isGlass: true,
  },
  {
    codigo: 'supervisor-analise-tributaria',
    name: 'Modulos do dashboard supervisor tax analysis',
    path: '/modulesHome/supervisor/tax-analysis',
    component: ModulesHomeSupervisorTaxAnalysisPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: House,
  },
  {
    codigo: 'supervisor-analise-tributaria-sn',
    name: 'Modulos do dashboard supervisor tax analysis simples nacional',
    path: '/modulesHome/supervisor/tax-analysis-sn',
    component: ModulesHomeSupervisorTaxAnalysisSNPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: House,
  },
  {
    codigo: 'icms-home',
    name: 'Modulo ICMS',
    path: '/modulesHome/supervisor/icms',
    component: IcmsHomePage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: House,
  },
  {
    codigo: 'icms-difal',
    name: 'DIFAL Carteira ICMS',
    path: '/modulesHome/supervisor/icms/difal',
    component: IcmsDifalCarteiraPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: House,
  },
  {
    codigo: 'icms-difal-empresa',
    name: 'DIFAL Empresa ICMS',
    path: '/modulesHome/supervisor/icms/difal/empresa/:codiEmp',
    component: IcmsDifalEmpresaPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: House,
  },
  {
    codigo: 'icms-acumuladores',
    name: 'Acumuladores ICMS',
    path: '/modulesHome/supervisor/icms/acumuladores',
    component: IcmsAcumuladoresHomePage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: House,
  },
  {
    codigo: 'icms-acumuladores-empresa',
    name: 'Acumuladores Empresa ICMS',
    path: '/modulesHome/supervisor/icms/acumuladores/empresa/:codiEmp',
    component: IcmsAcumuladoresEmpresaPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: House,
  },
  {
    codigo: 'icms-livros-fiscais',
    name: 'Livros Fiscais ICMS',
    path: '/modulesHome/supervisor/icms/livros-fiscais',
    component: IcmsLivrosFiscaisHomePage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: House,
  },
  {
    codigo: 'icms-livros-fiscais-empresa',
    name: 'Livros Fiscais Empresa ICMS',
    path: '/modulesHome/supervisor/icms/livros-fiscais/empresa/:codiEmp',
    component: IcmsLivrosFiscaisEmpresaPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: House,
  },
  {
    codigo: 'icms-regime-especial',
    name: 'Regime Especial ICMS',
    path: '/modulesHome/supervisor/icms/regime-especial',
    component: IcmsRegimeEspecialPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: House,
  },
  // Emissão de NFS-e pela API Nacional (TI-2026-0260). Módulo de vidro com menu próprio
  // (visão geral + 4 submódulos). /emitir/:id? é uma rota só para o formulário não ser
  // remontado quando o rascunho ganha id.
  {
    codigo: 'nfse-emissao',
    name: 'Emissão de NFS-e',
    path: '/modulesHome/supervisor/nfse-emissao',
    component: NfseEmissaoPainelPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: FileDoc,
    isGlass: true,
    hasDrillSidebar: true,
  },
  {
    codigo: 'nfse-emissao-emitir',
    name: 'Emitir NFS-e',
    path: '/modulesHome/supervisor/nfse-emissao/emitir/:id?',
    submoduleLink: '/modulesHome/supervisor/nfse-emissao/emitir',
    component: NfseEmissaoFormPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: FileDoc,
    isGlass: true,
  },
  {
    codigo: 'nfse-emissao-notas',
    name: 'Notas emitidas',
    path: '/modulesHome/supervisor/nfse-emissao/notas',
    component: NfseEmissaoNotasPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: FileDoc,
    isGlass: true,
  },
  {
    // Rota própria em vez de componentShow: o componentShow exige a ação 'show', que a
    // tela nfse-emissao não tem; aqui vale qualquer ação herdada do módulo.
    codigo: 'nfse-emissao-nota',
    name: 'Nota emitida',
    path: '/modulesHome/supervisor/nfse-emissao/notas/:itemId',
    component: NfseEmissaoNotaPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: FileDoc,
    isGlass: true,
  },
  {
    codigo: 'nfse-emissao-empresas',
    name: 'Empresas e cobertura',
    path: '/modulesHome/supervisor/nfse-emissao/empresas',
    component: NfseEmissaoEmpresasPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: FileDoc,
    isGlass: true,
  },
  {
    codigo: 'nfse-emissao-certificados',
    name: 'Certificados A1',
    path: '/modulesHome/supervisor/nfse-emissao/certificados',
    component: NfseEmissaoCertificadosPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: FileDoc,
    isGlass: true,
  },
  {
    codigo: 'planejamento-tributario-dashboard',
    name: 'Modulos do dashboard taxPlanning',
    path: '/modulesHome/taxPlanning',
    component: modulesHomeTaxPlanningPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: House,
  },
  {
    codigo: 'seguranca',
    name: 'Segurança',
    path: '/seguranca',
    component: SecurityPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    isChildrenMenu: false,
  },
  {
    codigo: 'perfil',
    name: 'Perfil',
    path: '/perfil',
    component: ProfilePage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    isChildrenMenu: false,
  },
  {
    codigo: 'sessoes',
    name: 'Sessões',
    path: '/sessoes',
    component: SessionsPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    isChildrenMenu: false,
  },
  {
    codigo: 'monitoramento',
    name: 'Monitoramento',
    path: '/monitoramento',
    component: RedirectToLogs,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
  },
  {
    codigo: 'eventos',
    name: 'Eventos',
    path: '/eventos',
    component: EventosPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: Ticket,
  },
  // Endereço antigo: as permissões do Kanban de Eventos ficam na Central de Permissões.
  {
    name: 'Permissões do Kanban de Eventos',
    path: '/eventos/permissoes',
    component: RedirectPermissoesEventos,
    showSidebar: false,
    hiddenSubmodule: true,
    semTela: true,
  },
  // So' redireciona para a aba Kanban da pagina do evento; a tela fica no RBAC porque e' ela que libera a aba.
  {
    codigo: 'eventos-kanban',
    name: 'Kanban de Eventos',
    path: '/eventos/kanban',
    component: EventosKanbanPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    hiddenSubmodule: true,
  },
  // Pagina do evento (abas Gerencial e Kanban). `path` com param + `component`, e nao `componentShow`: este
  // exige a acao `show`, que ninguem tem em eventos; com o param no path, o `hasPermission` cai no `/eventos`.
  // `/eventos/kanban`, `/permissoes` e `/contrato` sao estaticos e vencem o `:eventoId` no react-router.
  // O "sincronizar" cria a tela no RBAC; o nome avisa que ela nao restringe nada sozinha.
  {
    codigo: 'eventos-evento',
    name: 'Página do evento (segue a permissão de Eventos)',
    path: '/eventos/:eventoId',
    component: EventoPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    hiddenSubmodule: true,
  },
  // Preenchimento do contrato. Query param (`?evento=&contrato=`) e nao path
  // param: o router so' monta UM `:itemId` automaticamente, e o `hasPermission`
  // faz strip de `/:param` — dois parametros no path viram armadilha silenciosa.
  {
    codigo: 'eventos-contrato',
    name: 'Preenchimento de Contrato',
    path: '/eventos/contrato',
    component: EventoContratoPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    hiddenSubmodule: true,
  },
  {
    codigo: 'societario',
    name: 'Societário',
    path: '/societario',
    component: SocietarioHomePage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: Scales,
    isGlass: true,
    hasDrillSidebar: true,
  },
  {
    codigo: 'societario-legalizacao',
    name: 'Legalização',
    path: '/societario/legalizacao',
    component: LegalizacaoPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: Kanban,
    isGlass: true,
  },
  {
    codigo: 'societario-estatutos',
    name: 'Estatutos',
    path: '/societario/estatutos',
    component: EstatutoPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: GraduationCap,
    isGlass: true,
  },
  {
    codigo: 'societario-contratos',
    name: 'Contratos',
    path: '/societario/contratos',
    component: SocietarioContratosPage,
    componentCreate: SocietarioContratoCriarPage,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ClipboardText,
    isGlass: true,
  },
  {
    codigo: 'societario-socios',
    name: 'Sócios / Cadastros',
    path: '/societario/socios',
    component: SocietarioSociosPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: Users,
    isGlass: true,
  },
  {
    codigo: 'societario-admin-metrics',
    name: 'Métricas v2',
    path: '/societario/admin/metrics',
    component: SocietarioAdminMetricsPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartLineUp,
    isGlass: true,
  },
  {
    codigo: 'societario-templates',
    name: 'Templates',
    path: '/societario/templates',
    component: SocietarioTemplatesPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    hiddenSubmodule: true,
    icon: FileDoc,
    isGlass: true,
  },
  {
    codigo: 'societario-modelos',
    name: 'Modelos de referência',
    path: '/societario/modelos',
    component: SocietarioModelosPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    hiddenSubmodule: true,
    icon: FileDoc,
    isGlass: true,
  },
  {
    codigo: 'kanban',
    name: 'Kanban',
    path: '/kanban',
    component: KanbanProjectsPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: KanbanBoardPage,
    showSidebar: true,
    icon: Kanban,
  },
  {
    // Renomeado de 'Agentes de Automação' para 'Orquestrador' (21/08): o protótipo
    // organiza o módulo em WORKSPACE (Dashboard, Filas, Bots & Fluxos) e CONFIGURAR
    // (Parâmetros, Agendamentos, Máquinas, Acessos). Só o Dashboard entra agora;
    // 'Automação' e 'Config. de Bots' seguem como estão para não tirar do time as
    // telas que já usam, e vão sendo absorvidas conforme os itens do protótipo saem.
    //
    // O `codigo` NÃO mudou: ele é a chave de permissão em `tb_tela` e renomear aqui
    // derrubaria o acesso de quem já tem a tela liberada.
    codigo: 'agentes-automacao',
    name: 'Orquestrador',
    path: '/monitoramento',
    isParentMenu: true,
    component: RedirectToLogs,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: true,
    icon: Robot,
  },
  {
    codigo: 'orquestrador-dashboard',
    name: 'Dashboard',
    path: '/orquestrador',
    component: OrquestradorDashboardPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: true,
    isChildrenMenu: true,
    parentMenu: 'Orquestrador',
    icon: SquaresFour,
    isGlass: true,
  },
  {
    codigo: 'agentes-monitoramento',
    name: 'Monitoramento',
    path: '/monitoramento',
    component: RedirectToLogs,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    isChildrenMenu: true,
    icon: ChartLineUp,
  },
  {
    // Redirect strangler da tela antiga Analise de Bots (dashboards substituidos
    // pela tela /orquestrador). Sem `codigo` de proposito: a tela nao existe mais em
    // tb_tela; rota sem codigo e publica e serve so para manter bookmarks antigos.
    name: 'Analise de Bots',
    path: '/analise-bots',
    component: RedirectToAnalise,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
  },
  {
    // Cadastro/credenciais dos bots (aba Bots) + navegador de logs (aba Logs).
    // O acompanhamento (antigas abas Operacao/Analise/Empresas) foi substituido
    // pela tela /orquestrador; bookmarks antigos redirecionam de dentro da pagina.
    codigo: 'automacao',
    name: 'Automação',
    path: '/automacao',
    component: AutomacaoPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: true,
    isChildrenMenu: true,
    parentMenu: 'Orquestrador',
    icon: Robot,
  },
  {
    codigo: 'configuracao-bots',
    name: 'Config. de Bots',
    path: '/configuracao-bots',
    component: BotConfigPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: true,
    isChildrenMenu: true,
    parentMenu: 'Orquestrador',
    icon: Robot,
  },
  {
    codigo: 'whatsapp-chat',
    name: 'WhatsApp Chat',
    path: '/whatsapp',
    component: WhatsAppChatPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: House,
  },
  {
    codigo: 'whatsapp-dashboard',
    name: 'WhatsApp Dashboard',
    path: '/whatsapp/dashboard',
    component: WaDashboardWrapper,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartBar,
  },
  {
    codigo: 'whatsapp-kanban',
    name: 'WhatsApp Kanban',
    path: '/whatsapp/kanban',
    component: WaKanbanWrapper,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: Kanban,
  },
  {
    codigo: 'whatsapp-contatos',
    name: 'WhatsApp Contatos',
    path: '/whatsapp/clientes',
    component: WaClientsPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: Users,
  },
  {
    codigo: 'whatsapp-relatorios',
    name: 'WhatsApp Análise Inteligente',
    path: '/whatsapp/relatorios',
    component: WaReportsPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: ChartLineUp,
  },
  {
    codigo: 'whatsapp-historico',
    name: 'WhatsApp Historico',
    path: '/whatsapp/historico',
    component: WaHistoryPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: House,
  },
  {
    codigo: 'whatsapp-ai-insights',
    name: 'WhatsApp IA Insights',
    path: '/whatsapp/ai-insights',
    component: WaAiInsightsPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: House,
  },
  {
    codigo: 'whatsapp-templates',
    name: 'WhatsApp Templates',
    path: '/whatsapp/templates',
    component: WaTemplatesPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: WhatsappLogo,
  },
  {
    codigo: 'whatsapp-conexao',
    name: 'WhatsApp Conexão',
    path: '/whatsapp/conexao',
    component: WaConnectionPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    icon: WhatsappLogo,
  },
  {
    codigo: 'configuracoes',
    name: 'Configurações',
    path: '/configuracoes',
    isParentMenu: true,
    component: UsuariosRedireciona,
    componentCreate: UsuarioNovoNaCentral,
    componentEdit: UsuarioEditarNaCentral,
    componentShow: undefined,
    showSidebar: true,
    icon: GearSix,
  },
  {
    codigo: 'configuracoes-empresa',
    name: 'Sua empresa',
    path: '/configuracoes/sua-empresa',
    component: CompanyPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: true,
    isChildrenMenu: true,
    parentMenu: 'Configurações',
  },
  {
    codigo: 'configuracoes-grupos',
    name: 'Grupos de usuários',
    path: '/configuracoes/grupos',
    component: GroupsPage,
    componentCreate: GroupsCreatePage,
    componentEdit: GroupsEditPage,
    componentShow: undefined,
    // acessada pela Central de Permissões
    showSidebar: false,
    isChildrenMenu: true,
    parentMenu: 'Configurações',
  },
  {
    codigo: 'configuracoes-usuarios',
    name: 'Usuários',
    path: '/configuracoes/usuarios',
    component: UsuariosRedireciona,
    componentCreate: UsuarioNovoNaCentral,
    componentEdit: UsuarioEditarNaCentral,
    componentShow: undefined,
    // acessada pela Central de Permissões
    showSidebar: false,
    isChildrenMenu: true,
    parentMenu: 'Configurações',
  },
  {
    codigo: 'configuracoes-logs-acesso',
    name: 'Logs de acesso',
    path: '/configuracoes/logs-de-acesso',
    component: LogsNaCentral,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: true,
    naCentral: true,
    isGlass: true,
    isChildrenMenu: true,
    parentMenu: 'Configurações',
  },
  {
    codigo: 'configuracoes-departamentos',
    name: 'Departamentos',
    path: '/configuracoes/departamentos',
    component: DepartamentosNaCentral,
    componentCreate: DepartamentoNovoRedireciona,
    componentEdit: DepartamentoEditarRedireciona,
    componentShow: undefined,
    // acessada pela Central de Permissões
    showSidebar: false,
    isGlass: true,
    isChildrenMenu: true,
    parentMenu: 'Configurações',
  },
  {
    codigo: 'configuracoes-bot-whatsapp',
    name: 'Mensagens do bot (WhatsApp)',
    path: '/configuracoes/bot-whatsapp',
    component: WaBotConfigPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: true,
    isChildrenMenu: true,
    parentMenu: 'Configurações',
  },
  {
    codigo: 'configuracoes-ip-whitelist',
    name: 'Whitelist de IPs',
    path: '/configuracoes/ip-whitelist',
    component: IpWhitelistNaCentral,
    componentCreate: IpNovoRedireciona,
    componentEdit: IpEditarRedireciona,
    componentShow: undefined,
    showSidebar: true,
    naCentral: true,
    isGlass: true,
    isChildrenMenu: true,
    parentMenu: 'Configurações',
  },
  {
    codigo: 'configuracoes-api-controller',
    name: 'API Controller',
    path: '/configuracoes/api-controller',
    component: ApiControllerPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: true,
    isChildrenMenu: true,
    parentMenu: 'Configurações',
  },
  {
    codigo: 'configuracoes-permissoes',
    name: 'Central de Permissões',
    path: '/configuracoes/permissoes',
    component: CentralPermissoesPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: true,
    isChildrenMenu: true,
    parentMenu: 'Configurações',
    isGlass: true,
  },
  {
    codigo: 'configuracoes-permissoes-catalogo',
    name: 'Catálogo de telas',
    path: '/configuracoes/permissoes/catalogo',
    component: CatalogoTelasPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: false,
    isGlass: true,
  },
  // Endereço antigo do catálogo de telas.
  {
    name: 'Telas do Sistema',
    path: '/configuracoes/telas',
    component: RedirectTelasDoSistema,
    showSidebar: false,
    semTela: true,
  },
  {
    codigo: 'configuracoes-clientes',
    name: 'Clientes',
    path: '/configuracoes/clientes',
    component: ClientesNaCentral,
    componentCreate: ClienteNovoNaCentral,
    componentEdit: ClientesEditPage,
    componentShow: undefined,
    showSidebar: true,
    naCentral: true,
    isGlass: true,
    isChildrenMenu: true,
    parentMenu: 'Configurações',
  },
  {
    codigo: 'configuracoes-motivos-anotacao',
    name: 'Motivos de Anotação',
    path: '/configuracoes/motivos-anotacao',
    component: MotivosAnotacaoPage,
    componentCreate: undefined,
    componentEdit: undefined,
    componentShow: undefined,
    showSidebar: true,
    isChildrenMenu: true,
    parentMenu: 'Configurações',
  },
  // Endereço antigo: as permissões do grupo ficam na Central de Permissões.
  {
    name: 'Permissões do Grupo',
    path: '/configuracoes/grupos/permissoes/:itemId',
    component: RedirectPermissoesDoGrupo,
    showSidebar: false,
    semTela: true,
  },
];
